import React from "react";

const MPR = ({ color, iconStyle }) => {
  return (
    // <svg
    //   xmlns="http://www.w3.org/2000/svg"
    //   fill={color}
    //   version="1.1"
    //   id="Capa_1"
    //   width="16px"
    //   height="16px"
    //   viewBox="0 0 82.626 82.627"
    // >
    //   <g>
    //     <path d="M5.206,19.956l0.199,42.771c0.003,0.55,0.306,1.054,0.789,1.314l34.161,17.887c0.223,0.119,0.467,0.179,0.711,0.179   c0.001,0,0.002,0,0.003,0c0.103,0.117,0.218,0.227,0.355,0.309c0.236,0.141,0.502,0.212,0.769,0.212   c0.246,0,0.49-0.061,0.712-0.181l33.729-18.292c0.484-0.263,0.787-0.77,0.787-1.319v-44.5c0-0.013-0.005-0.025-0.005-0.039   c-0.001-0.011,0.003-0.021,0.003-0.033c-0.002-0.043-0.019-0.082-0.022-0.124c-0.013-0.082-0.022-0.164-0.047-0.243   c-0.018-0.055-0.041-0.104-0.064-0.157c-0.031-0.07-0.062-0.139-0.104-0.203c-0.031-0.05-0.068-0.095-0.105-0.141   c-0.047-0.058-0.096-0.112-0.152-0.163c-0.044-0.04-0.091-0.076-0.141-0.111c-0.032-0.022-0.059-0.053-0.094-0.073   c-0.032-0.02-0.069-0.028-0.104-0.045c-0.029-0.015-0.052-0.036-0.081-0.049L41.747,0.118c-0.405-0.171-0.864-0.155-1.258,0.042   L6.131,18.071c-0.504,0.254-0.822,0.77-0.825,1.333c0,0.009,0.004,0.017,0.004,0.025C5.249,19.596,5.205,19.772,5.206,19.956z    M72.456,18.501l-30.28,16.93L10.111,19.425L41.218,3.151L72.456,18.501z M43.692,78.61V38.021l30.729-17.173v41.09L43.692,78.61z" />
    //   </g>
    // </svg>
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="40"
      height="32"
      viewBox="0 0 40 32"
      fill="none"
      style={iconStyle}
    >
      <rect x="0.5" y="0.5" width="39" height="31" rx="4.5" fill="transparent" />
      <rect
        x="10.75"
        y="10.25"
        width="4.5"
        height="11.5"
        rx="1.25"
        stroke={color}
        strokeWidth="1.5"
      />
      <rect
        x="18.75"
        y="10.25"
        width="4.5"
        height="11.5"
        rx="1.25"
        stroke={color}
        strokeWidth="1.5"
      />
      <rect
        x="26.75"
        y="10.25"
        width="4.5"
        height="11.5"
        rx="1.25"
        stroke={color}
        strokeWidth="1.5"
      />
      <rect x="0.5" y="0.5" width="39" height="31" rx="4.5" stroke={color} />
    </svg>
  );
};

export default MPR;
